import {CompetitionPageMetaDataModel} from "../../../models/competition-page.meta-data.model";
import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";

export class CompetitionStandingsPageRouteMetaDataModel extends CompetitionPageMetaDataModel {
  @computed get filter() {
    return this.hasStandingsGroups ? METADATA_FILTERS.COMPETITION.groups : METADATA_FILTERS.COMPETITION.standings
  }

  @computed get pageTitle() {
    let title = this.hasStandingsGroups ? this.groupsTitle : this.standingsTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(this.filter)
    }

    return title;
  }

  @computed get description(): String {
    let description = this.hasStandingsGroups ? this.groupsDescription : this.standingsDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(this.filter)
    }

    return description;
  }

  get standingsTitle() {
    const standingsTitle = this.websiteTerms.COMPETITION_STANDINGS_TITLE_TEMPLATE.format({
      COMPETITION_NAME: this.competitionName,
      COMPETITION_GROUPS_TERM_IN_TITLE: this.websiteTerms.COMPETITION_GROUPS_TERM_IN_TITLE,
      COMPETITION_STANDINGS_TERM_IN_TITLE: this.websiteTerms.COMPETITION_STANDINGS_TERM_IN_TITLE
    });

    return standingsTitle
  }

  get standingsDescription() {
    const description = this.websiteTerms.COMPETITION_STANDINGS_DESCRIPTION_TEMPLATE.format({
      COMPETITION_NAME: this.competitionName,
      SPORT_TYPE: this.competitionSportName
    });

    return description
  }

  get groupsTitle() {
    const groupsTitle = this.websiteTerms.COMPETITION_GROUPS_TITLE_TEMPLATE.format({
      COMPETITION_NAME: this.competitionName,
      COMPETITION_GROUPS_TERM_IN_TITLE: this.websiteTerms.COMPETITION_GROUPS_TERM_IN_TITLE,
      COMPETITION_STANDINGS_TERM_IN_TITLE: this.websiteTerms.COMPETITION_STANDINGS_TERM_IN_TITLE
    });

    return groupsTitle
  }

  get groupsDescription() {
    const description = this.websiteTerms.COMPETITION_GROUPS_DESCRIPTION_TEMPLATE.format({
      COMPETITION_NAME: this.competitionName,
      SPORT_TYPE: this.competitionSportName
    });

    return description
  }
}